import deepmerge from 'deepmerge';
var localeMap = new WeakMap();
export default function merge(base, target) {
  var result = localeMap.get(target);

  if (!result) {
    result = deepmerge(base, target, {
      arrayMerge: function arrayMerge(_destinationArray, sourceArray) {
        return sourceArray;
      }
    });
    localeMap.set(target, result);
  }

  return result;
}